<template>
  <div class="fullwidth narex collections">
    <my-area-nav />
    <div class="collection-view">
      <div class="collection-title">
        {{ $store.state.profileFolder }}
      </div>
      <div class="collection-controls">
        <small-button v-on:click="handleEmail">Email collection</small-button>
      </div>
      <div class="flex-images">
        <collection-image v-for="image in images" :image="image" :key="image.image_id"
          v-on:likeClicked="loadData" v-on:zoom="handleZoom" />
        <div v-for="n in extraImages" :key="'xtra' + n" class="imdiv"></div>
      </div>
    </div>
    <zoom-image :visible="showZoom" v-on:prev="zoomImage(-1)" v-on:next="zoomImage(1)" :image="selImage" v-on:close="closeZoom" />
    <collection-emailer :visible="emailing" v-on:close="emailing = false" v-on:send="handleSend" />
  </div>
</template>

<script>
import MyAreaNav from './MyAreaNav.vue'
import apix from '@/api.js'
import CollectionImage from '@/components/widgets/CollectionImage.vue'
import ZoomImage from '@/components/panels/ZoomImage.vue'
import likeUtils from '@/utils/likes.js'
import CollectionEmailer from './CollectionEmailer.vue'
import '@/css/my-area.css'

export default {
  components: {
    MyAreaNav,
    CollectionImage,
    ZoomImage,
    CollectionEmailer
  },
  data () {
    return {
      images: [],
      extraImages: 0,
      showZoom: false,
      curpos: 0,
      selImage: null,
      loaded: false,
      emailing: false
    }
  },
  created () {
    if(!this.$store.state.signedIn) {
      this.$ixr.push('/')
    }
    else {
      this.loadData()
    }
  },
  mounted () {
    window.addEventListener('resize', this.setExtraImages)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setExtraImages)
  },
  methods: {
    getCurrentPos: function () {
      if(!this.selImage.image_id) return -1
      return this.images.findIndex(el => el.image_id === this.selImage.image_id)
    },
    handleZoom (image) {
      this.selImage = image
      this.showZoom = true
    },
    zoomImage: function (moveRel) {
      let pos = this.getCurrentPos()
      if(pos < 0) {
        pos = 0
      }
      else {
        pos += moveRel
        if(pos < 0) {
          pos = this.images.length - 1
        }
        else if (pos >= this.images.length) {
          pos = 0;
        }
      }
      this.selImage = this.images[pos]
    },
    setExtraImages () {
      let rowWidth = this.$k.getBreakpoint().columns
      let extra = this.images.length % rowWidth
      if(extra > 0) {
        this.extraImages = rowWidth - extra
      }
    },
    async closeZoom () {
      this.showZoom = false
      await this.$k.waitfor(200)
      this.selImage = null
    },
    async loadData () {
      this.loaded = false
      let likes = this.$store.state.likes
      let image_ids = likes.filter((item, pos) => likes.indexOf(item) === pos)
      let res = await apix.post('collections/images', { image_ids: image_ids })
      this.images = res.data
      // we can filter out images that don't exist here
      this.filterExisting()
      this.setExtraImages()
      this.currentPos = 0
      this.loaded = true
    },
    filterExisting(){
      let likes = this.$store.state.likes
      let existing = []
      for(let each of this.images) {
        existing.push(each.image_id)
      }
      if(existing.length !== likes.length) {
        console.log('going to update')
        let imds = existing.join(',')
        let folder = { name: this.$store.state.profileFolder, image_ids: imds }
        this.$store.commit('setFolder', folder)
        likeUtils.updateFolder(this.$store.state, folder)
      }
    },
    handleEmail () {
      this.emailing = true
    },
    handleSend () {
      console.log('Would send email here')
    }

  },
  watch: {
    '$store.state.signedIn': function () {
      if(!this.$store.state.signedIn) {
        this.$ixr.push('/')
      }
    },
    '$store.state.profileFolder': function () {
      this.loadData()
    }
  }
}
</script>

<style>
.collection-view{
  margin:20px 0;
}

.collection-title{
  font-weight:500;
  font-size:24px;
  margin-bottom:12px;
}

.collection-controls{
  margin-bottom:12px;
}

.collections .flex-images{
  min-height:200px;
}
</style>